<template>
  <div>
    <el-drawer
      :title="`${disabled ? '查看' : '上传'}设备共用文档`"
      :visible.sync="drawer"
      :close-on-press-escape="false"
      :wrapperClosable="false"
      size="100%"
      :before-close="beforeClose"
      @close="closeDrawer"
    >
      <!-- <div style="overflow-y: auto; width: 100%; position: relative"></div> -->
      <div
        style="
          width: 100%;
          flex-wrap: wrap;
          height: calc(100vh - 100px);
          overflow-y: auto;
          overflow-x: hidden;
          position: relative;
        "
        v-loading.fullscreen.lock="loading"
      >
        <div
          style="
            width: 100%;
            background-color: #fff;
            padding: 10px;
            border-radius: 5px;
            display: flex;
            align-items: center;
            position: sticky;
            top: 0;
            right: 0;
            z-index: 99;
          "
        >
          <div style="width: calc(100% - 200px)">
            <span style="font-size: 18px; font-weight: bold; color: #72767b">
              当前选择设备：</span
            >
            <el-tag
              style="margin-left: 10px; margin-bottom: 10px; margin-top: 10px"
              v-for="(item, index) in DeviceNames"
              :key="item + index"
              type="success"
              >{{ item }}</el-tag
            >
          </div>
          <div style="width: 200px" v-if="!disabled">
            <el-button type="primary" @click="DocumentSubmit"
              >保存文档</el-button
            >
            <!-- <el-checkbox
              v-model="isUpCheckbox"
              @change="upCheckboxChange"
              style="margin-right: 20px"
              :disabled="disabled"
              >全选</el-checkbox
            >
            <el-button type="primary" @click="upAllData" size="mini" :disabled="disabled"
              >上传文档信息</el-button
            > -->
          </div>
        </div>
        <div
          v-for="item in fileTableList"
          :key="item.FiledKey"
          :style="`width:${
            100 / item.width
          }%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;`"
        >
          <el-table
            style="width: 100%"
            size="mini"
            :data="
              item.device_TypeTwoDocuments.filter((vall) =>
                item.cList.includes(vall.Type)
              )
            "
          >
            <!-- <el-table-column type="sele" width="40" align="center" :resizable="false">
              <template slot-scope="scope">
                <el-checkbox
                  :disabled="disabled"
                  v-model="scope.row.checked"
                  @change="checkedChange(scope.row)"
                ></el-checkbox>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="TypeName"
              :label="item.FieldName"
              :resizable="false"
            >
              <template slot-scope="scope">
                <span style="color: red" v-if="scope.row.disabled">*</span>
                <!-- +
                                `(${scope.row.PrivateOrShared == 0 ? "共用" : "私有"})` -->
                {{ scope.row.TypeName }}
              </template>
            </el-table-column>

            <el-table-column prop="Type" label="文件信息" :resizable="false">
              <!-- :before-remove="(file) => beforeRemove(file, item)"
                          :on-remove="
                            (file, fileList) => handleRemove(file, fileList, item)
                          " -->
              <!-- :on-success="
                            (response, file, fileList) =>
                              handleSuccess(response, file, fileList, item)
                          "
                          :on-error="
                            (err, file, fileList) =>
                              handleError(err, file, fileList, item)
                          " -->
              <!-- DataInfo[DataInfo.DeviceTab][item.FiledKey]-->
              <template slot-scope="scope">
                <el-upload
                  :limit="9"
                  class="upload-demo"
                  :action="
                    $rootUrl +
                    `/Base_Manage/Upload/ProjectOssUploadFileByForm?ProjectId=${ProjectId}&UserId=${SupplierId}&type=3&SupplierId=${SupplierId}&DeviceType=${treeId}`
                  "
                  :ref="'upload_' + scope.row.Type"
                  multiple
                  :disabled="scope.row.IsUpStatus || disabled"
                  :headers="{
                    Authorization: 'Bearer ' + TokenCache.getToken(),
                  }"
                  accept="image/*, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                  :before-upload="
                    (file, fileList) => beforeUpload(scope.row, file, fileList)
                  "
                  :file-list="fileInfo[scope.row.Type + 'List']"
                  :on-exceed="handleExceed"
                  :on-preview="handlePreview"
                  :on-change="
                    (file, fileList) =>
                      handleChange(file, fileList, scope.row.Type)
                  "
                  :on-success="
                    (response, file, fileList) =>
                      handleSuccess(response, file, fileList, scope.row)
                  "
                  :on-error="
                    (err, file, fileList) =>
                      handleError(err, file, fileList, scope.row)
                  "
                  :on-remove="
                    (file, fileList) => handleRemove(file, fileList, scope.row)
                  "
                  :auto-upload="true"
                >
                  <div v-if="!disabled">
                    <el-button
                      size="mini"
                      type="primary"
                      :disabled="scope.row.IsUpStatus || disabled"
                      :loading="scope.row.IsUpStatus"
                      >{{
                        scope.row.IsUpStatus ? '上传中' : '选择文件'
                      }}</el-button
                    >
                  </div>
                </el-upload>
              </template>
            </el-table-column>
            <el-table-column
              prop="TypeName"
              label="文件大小"
              :resizable="false"
            >
              <template slot-scope="scope">
                <div
                  v-for="item in fileInfo[scope.row.Type + 'List']"
                  :key="item.uid"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    style="
                      width: calc(100% - 120px);
                      display: flex;
                      align-items: center;
                    "
                  >
                    {{ item.name }}
                  </div>
                  <div style="width: 120px; display: flex; align-items: center">
                    {{ setSize(item.size) }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="上传状态" width="100" align="center">
              <template slot-scope="scope">
                <i
                  class="el-icon-circle-check"
                  style="font-size: 20px; color: #67c23a"
                  v-if="
                    fileInfo[scope.row.Type + 'List']?.length > 0 &&
                    fileInfo[scope.row.Type + 'List']?.every(
                      (item) => item.status === 'success'
                    )
                  "
                ></i>
                <i
                  v-else
                  class="el-icon-circle-close"
                  style="font-size: 20px; color: #f56c6c"
                ></i>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="options"
              label="操作"
              :resizable="false"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="!disabled"
                  @click="upData(scope.row)"
                  :loading="scope.row.IsUpStatus"
                  type="primary"
                  size="mini"
                  :disabled="disabled"
                  >{{ scope.row.IsUpStatus ? "上传中" : "上传" }}</el-button
                >
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import TokenCache from '@/utils/cache/TokenCache'
export default {
  data() {
    return {
      TokenCache,
      drawer: false,
      disabled: false,
      selectionRows: [],
      treeId: '',
      ProjectId: '',
      treeName: '',
      SupplierId: '',
      loading: false,
      fileTableList: [],
      fileInfo: {},
      isUpCheckbox: false,
      DeviceNames: [],
    }
  },
  props: {},
  components: {},
  methods: {
    DocumentSubmit(ele) {
      let arr = []
      console.log(this.fileTableList, '222')
      this.fileTableList.forEach((item) => {
        item.device_TypeTwoDocuments.forEach((val) => {
          if (
            val.disabled == 1 &&
            this.fileInfo[val.Type] &&
            this.fileInfo[val.Type].length <= 0
          ) {
            arr.push(val)
          }
        })
      })
      if (arr.length > 0) {
        return this.$notify.error(
          '请上传' +
            arr.map((item) => item.TypeName).join('、') +
            '全部文件后进行保存'
        )
      }
      console.log(this.fileInfo)
      console.log(arr, 'arr')

      this.loading = true
      this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/SubmitDeviceDocumentData', {
          DeviceIds: [...this.selectionRows.map((item) => item.Id)],
          PrivateOrShared: 0,
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.$notify.success('文档保存成功')
            this.$emit('success')
          }
        })
    },
    //文档信息保存
    async submitData(item, isDete) {
      console.log(item, 'item')
      console.log('上传完成1233333333333333333333')

      let obj = {}
      this.$set(obj, item.Type, this.fileInfo[item.Type])
      // console.log({
      //   DeviceType: this.treeId,
      //   DeviceTab: "DocumentInformation",
      //   Type: item.Type,
      //   DataJson: obj,
      // });

      // Device_TypeWork/Device_TypeTemplate/SaveTemplateSupplierData
      this.loading = true
      await this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/SaveDocumentShareData', {
          DeviceIds: this.selectionRows.map((val) => val.Id),
          DeviceType: this.treeId,
          ProjectId: this.ProjectId,
          DeviceTab: 'DocumentInformation',
          SupplierId: this.SupplierId,
          DataJson: JSON.stringify(obj),
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            // this.TemplateData[this.DataInfo.DeviceTab];

            if (!isDete) {
              this.$notify.success(`【${item.TypeName}】文档信息上传保存成功`)
            } else {
              this.$notify.success(`删除成功`)
            }
            // this.DeviceId = res.Data;
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    //字节转换
    setSize(size) {
      let data = ''
      const _size = Number.parseFloat(size)
      if (_size < 1 * 1024) {
        //如果小于0.1KB转化成B
        data = _size.toFixed(2) + 'B'
      } else if (_size < 1 * 1024 * 1024) {
        //如果小于0.1MB转化成KB
        data = (_size / 1024).toFixed(2) + 'KB'
      } else if (_size < 1 * 1024 * 1024 * 1024) {
        //如果小于0.1GB转化成MB
        data = (_size / (1024 * 1024)).toFixed(2) + 'MB'
      } else {
        //其他转化成GB
        data = (_size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
      }
      const size_str = data + ''
      const len = size_str.indexOf('.')
      const dec = size_str.substr(len + 1, 2)
      if (dec == '00') {
        //当小数点后为00时 去掉小数部分
        return size_str.substring(0, len) + size_str.substr(len + 3, 2)
      }
      return size_str
    },
    handlePreview(file) {
      console.log(file)
      window.open(file.url || file.response.Url || file.response.url)
    },
    handleExceed(files, fileList) {
      this.$notify.warning(
        `当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    beforeRemove(file, item) {
      console.log(file, item, '删除之前文件')
      return new Promise((response, reject) => {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            console.log(file)
            return response()
          })
          .catch(() => {
            return reject()
          })
      })
    },
    //上传删除文件
    async handleRemove(file, fileList, row) {
      console.log(file, fileList, row, '删除文件')
      this.fileInfo[row.Type + 'List'] = fileList
      // console.log(this.form[item.FiledKey + "fileList"], "fileList");
      let index = this.fileInfo[row.Type].findIndex((val) => {
        return val.uid === file.uid
      })
      if (index > -1) {
        this.fileInfo[row.Type].splice(index, 1)
      }
      if (file.status == 'success') {
        //如果已上传的删除则执行删除接口
        this.submitData(row, true)
      }
    },
    //上传成功
    handleSuccess(response, file, fileList, row) {
      console.log(
        JSON.parse(
          JSON.stringify({
            response,
            file,
            fileList,
            row,
          })
        ),
        '22222222222222'
      )

      //上传成功的赋值到保存参数里
      if (response.code == '200' && file.status == 'success') {
        this.fileInfo[row.Type] = [
          ...this.fileInfo[row.Type],
          {
            name: file.name,
            size: file.size,
            uid: file.uid,
            url: file.response.url,
            status: file.status,
            resname: response.name,
          },
        ]
        console.log(this.fileInfo[row.Type], 'TypeTypeTypeTypeTypeType')
      }
      //验证是否全部上传完毕
      this.fileInfo[row.Type + 'UpStatus'] = fileList.every((val) => {
        return val.status == 'success'
      })
      //全部上传完毕保存数据
      if (this.fileInfo[row.Type + 'UpStatus']) {
        row.IsUpStatus = false
        this.submitData(row)
      }
      // console.log(JSON.parse(JSON.stringify(response)), "response");
      // console.log(JSON.parse(JSON.stringify(file)), "file");
      // console.log(JSON.parse(JSON.stringify(fileList)), "fileList");
      // console.log(JSON.parse(JSON.stringify(item)), "item");
      // console.log(response, file, fileList, item, "上传成功");
      // if (this.isUp) {
      //   this.submitData();
      // }
      // this.form[item.FiledKey] = file.response.Data;
    },
    beforeUpload(row, file, fileList) {
      const isImage = file.type.startsWith('image/')
      const allowedDocumentExtensions = [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
      ]
      const fileExtension = file.name.split('.').pop().toLowerCase()

      // 验证是否为图片或文档
      if (!isImage && !allowedDocumentExtensions.includes(fileExtension)) {
        this.$notify.error('只能上传图片或文档文件！')
        return false
      } else {
        row.IsUpStatus = true
        return true
      }
    },
    //上传失败
    handleError(err, file, fileList, row) {
      console.log(err, file, fileList, row, '上传失败')
      row.IsUpStatus = false
      this.$notify.error('上传失败')
    },
    //文件改变状态
    handleChange(file, fileList, Type) {
      console.log(Type)
      // this.form[item.FiledKey + "fileList"] = [...fileList];
      this.fileInfo[Type + 'List'] = [...fileList]
      // console.log(file, fileList, item, "文件改变状态");
    },
    //全选选择
    upCheckboxChange(val) {
      console.log(val, '全选')
      if (val) {
        this.fileTableList.forEach((item) => {
          let data = item.device_TypeTwoDocuments.filter((vall) =>
            item.cList.includes(vall.Type)
          )
          data.forEach((ele) => {
            console.log(ele, '22222')

            this.$set(ele, 'checked', true)
          })
        })
      } else {
        this.fileTableList.forEach((item) => {
          let data = item.device_TypeTwoDocuments.filter((vall) =>
            item.cList.includes(vall.Type)
          )
          data.forEach((ele) => {
            console.log(ele, '22222')

            this.$set(ele, 'checked', false)
          })
        })
      }
    },
    //选择多选
    checkedChange(row) {
      console.log(row, '选择多选')
      let arr = this.fileTableList.map((item) => {
        return item.device_TypeTwoDocuments.filter((vall) =>
          item.cList.includes(vall.Type)
        )
      })
      let ArrData = arr.flat(9999999)
      this.isUpCheckbox = ArrData.every((val) => {
        return val.checked
      })

      //  this.TemplateData[this.DataInfo.DeviceTab].forEach((item) => {
      //     let data = item.device_TypeTwoDocuments.filter((vall) =>
      //       item.cList.includes(vall.Type)
      //     );
      //     data.forEach((ele) => {
      //       console.log(ele, "22222");

      //       this.$set(ele, "checked", true);
      //     });
      //   });
      console.log(row)
    },
    //上传全部
    async upAllData() {
      //获取所有table数据
      let arr = this.fileTableList.map((item) => {
        return item.device_TypeTwoDocuments.filter((vall) =>
          item.cList.includes(vall.Type)
        )
      })
      // 获取选中的数据
      let ArrData = arr.flat(9999999).filter((item) => {
        return item.checked
      })
      if (ArrData.length <= 0) {
        return this.$notify.error('请选择需要上传的文档信息')
      }
      //验证是否选中的项都有文件
      let errArr = []
      ArrData.forEach((item) => {
        if (this.fileInfo[item.Type + 'List'].length <= 0) {
          errArr.push(item)
        }
      })
      if (errArr.length > 0) {
        return this.$notify.error('选择的文档信息中有未选择文件，请核实后上传')
      }
      //判断选中的都已上传过 如选中的都已保存过则循环重新保存一次
      let ArrDataSuccess = []
      ArrData.forEach((item) => {
        let flag = this.fileInfo[item.Type + 'List'].every((val) => {
          return val.status == 'success'
        })
        // 选中的为上传则执行上传组件
        if (flag) {
          ArrDataSuccess.push(item)
        } else {
          console.log(item, 'itemitem')
          //使当前上传按钮为上传中状态
          item.IsUpStatus = true
          this.$refs['upload_' + item.Type][0].submit()
        }
      })

      //判断选中的都已上传过 如选中的都已保存过则循环重新保存一次
      if (ArrDataSuccess.length === ArrData.length) {
        for await (const item of ArrData) {
          await this.submitData(item)
        }
        console.log('00000000000000000000000000000000000000')
        // ArrData.forEach((item) => {
        //   this.submitData(item.Type);
        // });
      } else {
        for await (const item of ArrDataSuccess) {
          await this.submitData(item)
        }
      }
      console.log(ArrData)
    },
    //上传按钮
    upData(row) {
      if (this.fileInfo[row.Type + 'List'].length <= 0) {
        return this.$notify.error('请选择需要上传的文件')
      }

      //判断当前行是否全部文件已上传过 上传过则执行一次保存
      let flag = this.fileInfo[row.Type + 'List'].every((val) => {
        return val.status == 'success'
      })
      if (flag) {
        this.submitData(row)
        return
      }
      // 未上传 则执行上传组件执行上传
      row.IsUpStatus = true
      this.$refs['upload_' + row.Type][0].submit()
    },
    async getInfoData() {
      this.loading = true
      await this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/GetDocumentShareData', {
          DeviceId: this.selectionRows[0].Id,
          DeviceType: this.treeId,
          ProjectId: this.ProjectId,
          SupplierId: this.SupplierId,
        })
        .then((res) => {
          this.loading = false
          this.$set(this, 'fileInfo', res.Data)
        })
    },
    getDataList() {
      this.loading = true
      this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/GetShareDocument', {
          ProjectId: this.ProjectId,
          DeviceType: this.treeId,
          DeviceIds: this.selectionRows.map((item) => item.Id),
        })
        .then((res) => {
          if (res.Success) {
            this.loading = false
            this.DeviceNames = res.Data.DeviceNames
            this.fileTableList = res.Data.DocumentData

            this.fileTableList.forEach((item) => {
              item.device_TypeTwoDocuments.forEach((val) => {
                this.$set(val, 'checked', false)
              })
              item.cList.forEach((val) => {
                //回填获取TypeList
                this.$set(this.fileInfo, val, this.fileInfo[val] || [])
                //复制渲染数据挂载上传组件 上传组件用type+List方式为fileList
                this.$set(
                  this.fileInfo,
                  val + 'List',
                  JSON.parse(JSON.stringify(this.fileInfo[val] || [])) || []
                )
                this.$set(this.fileInfo, val + 'UpStatus', false)
              })
            })
            console.log(this.fileInfo, 'fileInfofileInfofileInfo')
          }
        })
    },
    // 打开        选中数据 设备分类ID 设备分类名称 项目ID 供应商ID
    async openDrawer(
      selectionRows,
      treeId,
      treeName,
      ProjectId,
      SupplierId,
      disabled
    ) {
      this.SupplierId = SupplierId
      this.treeId = treeId
      this.treeName = treeName
      this.ProjectId = ProjectId
      this.selectionRows = selectionRows
      this.disabled = disabled ? true : false

      this.fileInfo = {}
      this.drawer = true
      if (disabled) {
        await this.getInfoData()
      }
      this.getDataList()
    },
    beforeClose(done) {
      if (!this.disabled) {
        this.$confirm(
          '请确认是否已保存数据，关闭后未保存的数据将清空，确认关闭吗？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            done()
          })
          .catch(() => {})
      } else {
        done()
      }
    },
    closeDrawer() {
      this.drawer = false
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
::v-deep .el-drawer__header {
  margin-bottom: 20px;
}
::v-deep .el-upload-list {
  padding: 5px;
}
::v-deep .upload-demo {
  display: flex;
  align-items: center;
}
</style>
